<template>
  <v-row
    align="center"
    justify="start"
  >
    <v-btn
      plain
      large
      rounded
      class="font-weight-bold my-3"
      @click="openPopUp"
    >
      <v-icon size="24" right class="px-4">mdi-account-plus</v-icon>
    </v-btn>

    <v-overlay
      :value="popup"
      opacity="0.5"
    >
      <v-card
        width="570"
        light
      >
        <v-container class="px-5">
          <div v-if="!loading">
            <div class="full-width d-flex justify-end">
              <v-btn icon @click="closePopUp">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
              class="pb-4 pt-0 mt-0"
              @click.stop
            />
            <v-data-table
              :items="customersWithoutSession"
              :search="search"
              :hide-default-footer="true"
              :hide-default-header="true"
              :items-per-page="-1"
              :height="tableHeight"
              :headers="headers"
              show-select
              item-key="uuid"
              :custom-filter="filter"
              single-select
              @item-selected="selectItem"
              @click:row="rowClick"
            />
          </div>
          <div v-else>
            <div class="d-flex justify-center align-center" :style="{ height: tableHeight + 'px' }">
              <Loader />
            </div>
          </div>
        </v-container>
      </v-card>
    </v-overlay>
  </v-row>
</template>

<script>
import { ref, computed, provide, inject } from '@vue/composition-api';

import { getContractWithStock } from '../../helpers/request';

import Loader from '../common/Loader.vue';

import { separateContentTypesWithAndWithoutSession } from '@/helpers/dataManager';
import { sendNotification, sortArray } from '@/helpers/utils';

export default {
  components: { Loader },
  props: {
    session: {
      type: Object,
      default () {
        return {};
      }
    },
    index: {
      type: Number,
      default: -1
    },
    participantHorseList: {
      type: Array,
      default () {
        return [];
      }
    }
  },
  setup (props) {
    const search = ref(null);
    const popup = ref(false);
    const headers = [
      { text: 'Prénom', value: 'firstname', isFieldfilterable: true },
      { text: 'Nom', value: 'lastname', isFieldfilterable: true },
      { text: 'Email', value: 'email', isFieldfilterable: true }
    ];
    const loading = ref(false);

    const selectParticipantModalData = inject('selectParticipantModalData');
    const showParticipantModal = inject('showParticipantModal');

    const tableHeight = computed(() => window.innerHeight * 0.5);

    const customersWithoutSession = computed(() => {
      const { without_session, with_session } = separateContentTypesWithAndWithoutSession('customer');

      const customers = [...without_session];

      with_session.map(customer => {
        if (!(props.session.participants || []).some(p => p.uuid === customer.uuid)) {
          customers.push(customer);
        }
      });

      return sortArray(customers, 'fullname');
    });

    const openPopUp = () => {
      popup.value = true;
    };

    const closePopUp = () => popup.value = false;

    const filter = (_, searchValue, item) => {
      const fields = headers.filter(h => h.isFieldfilterable);

      return fields.some(field => item[field.value] && item[field.value].toLowerCase().includes(searchValue.toLowerCase()));
    };

    const selectItem = async ({ item }) => {
      loading.value = true;
      const { uuid } = item;

      if (!uuid) {
        sendNotification('error', 'client introuvable');
        return;
      }
      const contracts = await getContractWithStock(item.uuid);
      selectParticipantModalData.value = { contracts: contracts.data, user: item, session: props.session, participantHorse: props.participantHorseList[props.index] };
      showParticipantModal.value = true;
      closePopUp();
      loading.value = false;
    };

    const rowClick = (item, row) => {
      event.stopPropagation();
      row.select(!row.isSelected);
    };

    provide('closePopUp', closePopUp);

    return { customersWithoutSession, loading, openPopUp, search, popup, headers, filter, selectItem, rowClick, closePopUp, tableHeight };
  }
};
</script>

<style>
  #tablepopup > div > table{
    table-layout: auto;
  }
  #tablepopup tr {
    cursor: pointer;
  }
</style>
